import React from 'react';

export default function LiveBadge(props) {
    return (
        <div className={"flex items-center p-1 font-bold text-xs text-cs14 " + props.className}>
            <div className="inline-block h-[5px] w-[5px] bg-cs14 rounded-full"></div>
            <span className="ml-1 leading-[0.6rem] uppercase">Live</span>
        </div>
    );
}
